@import "~@uipath/apollo-core/src/scss/base-host.scss";

.portal-material-checkbox {
  z-index: 0;
  position: relative;
  display: flex;
  align-items: center;
}

/* Input */
.portal-material-checkbox > input {
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  z-index: -1;
  position: absolute;
  left: 1px;
  top: 3px;
  display: block;
  margin: 0;
  width: 18px;
  height: 18px;
  background-color: rgba(var(--color-foreground-de-emp), 0);
  box-shadow: none;
  transform: scale(1);
  pointer-events: none;
  transition: background-color 0.3s, transform 0.2s;
}

/* .portal-material-checkbox-label */
.portal-material-checkbox > .portal-material-checkbox-label {
  display: inline-block;
  width: 100%;
  cursor: pointer;
}

/* Box */
.portal-material-checkbox > .portal-material-checkbox-before {
  content: "";
  display: inline-block;
  box-sizing: border-box;
  margin: 3px 11px 3px 1px;
  border: solid 2px; /* Safari */
  border-color: var(--color-foreground-de-emp);
  border-radius: 2px;
  width: 18px;
  height: 18px;
  min-width: 18px;
  vertical-align: top;
  transition: border-color 0.2s, background-color 0.2s;
}

/* Checkmark */
.portal-material-checkbox > .portal-material-checkbox-after {
  content: "";
  display: block;
  position: absolute;
  top: 3px;
  left: 1px;
  width: 10px;
  height: 5px;
  border: solid 2px transparent;
  border-right: none;
  border-top: none;
  transform: translate(3px, 4px) rotate(-45deg);
}

/* Checked */
.portal-material-checkbox > input:checked {
  background-color: var(--color-primary);
}

.portal-material-checkbox > input:checked + .portal-material-checkbox-before {
  border-color: var(--color-primary);
  background-color: var(--color-primary);
}

.portal-material-checkbox-checked > .portal-material-checkbox-after {
  border-color: var(--color-background);
}

/* Hover, Focus */
.portal-material-checkbox:hover > input {
  background-color: rgba(var(--color-foreground-de-emp), 0.04);
}

.portal-material-checkbox > input:focus {
  background-color: rgba(var(--color-foreground-de-emp), 0.12);
}

.portal-material-checkbox:hover > input:focus {
  background-color: rgba(var(--color-foreground-de-emp), 0.16);
}

/* Active */
.portal-material-checkbox > input:active {
  background-color: rgba(var(--color-foreground-de-emp), 1);
  transform: scale(0);
  transition: transform 0s, opacity 0s;
}

.portal-material-checkbox > input:active + .portal-material-checkbox-before {
  border-color: var(--color-primary);
}

.portal-material-checkbox > input:checked:active + .portal-material-checkbox-before {
  border-color: transparent;
  background-color: var(--color-foreground-de-emp);
}
